import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function positiveNumberValidator(options?: { allowZero?: boolean }): ValidatorFn {
  const allowZero = options?.allowZero ?? true;

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value === null || value === undefined || value === "") {
      return null; // Let required validator handle empty values
    }

    const numeric = +value;

    if (isNaN(numeric)) {
      return { notPositive: true };
    }

    return allowZero ? (numeric >= 0 ? null : { notPositive: true }) : numeric > 0 ? null : { notPositive: true };
  };
}
